const { 
  GET_LIST_QUARTERTARIFF, 
  GET_LIST_QUARTERTARIFF_SUCCESS, 
  GET_LIST_QUARTERTARIFF_FAIL,
  UPSERT_QUARTERTARIFF,
  UPSERT_QUARTERTARIFF_SUCCESS,
  UPSERT_QUARTERTARIFF_FAIL,
  DELETE_QUARTERTARIFF,
  DELETE_QUARTERTARIFF_SUCCESS,
  DELETE_QUARTERTARIFF_FAIL,
  RESET_QUARTERTARIFF_MESSAGES
} = require("./actionTypes")


const INIT_STATE = {
    lstQuarterTariff: [],
    error: null,
    success: null,
    loading: false,
    upsertLoading: false,
    deleteLoading: false,
  }

  const reducer = (state = INIT_STATE, action) => {
    switch (action.type) {
      // Get List
      case GET_LIST_QUARTERTARIFF:
        return {
          ...state,
          loading: true,
        }
      case GET_LIST_QUARTERTARIFF_SUCCESS:
        return {
          ...state,
          lstQuarterTariff: action.payload,
          loading: false,
          success: "",
          error: null,
        }
      case GET_LIST_QUARTERTARIFF_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload ? action.payload : "خطای پیش بینی نشده",
          success: "",
        }

      // Upsert
      case UPSERT_QUARTERTARIFF:
        return {
          ...state,
          upsertLoading: true,
          error: null,
          success: null,
        }
      case UPSERT_QUARTERTARIFF_SUCCESS:
        return {
          ...state,
          upsertLoading: false,
          success: "عملیات با موفقیت انجام شد",
          error: null,
        }
      case UPSERT_QUARTERTARIFF_FAIL:
        return {
          ...state,
          upsertLoading: false,
          error: action.payload ? action.payload : "خطای پیش بینی نشده",
          success: null,
        }

      // Delete
      case DELETE_QUARTERTARIFF:
        return {
          ...state,
          deleteLoading: true,
          error: null,
          success: null,
        }
      case DELETE_QUARTERTARIFF_SUCCESS:
        return {
          ...state,
          lstQuarterTariff: state.lstQuarterTariff.filter(item => item.id !== action.payload),
          deleteLoading: false,
          success: "حذف با موفقیت انجام شد",
          error: null,
        }
      case DELETE_QUARTERTARIFF_FAIL:
        return {
          ...state,
          deleteLoading: false,
          error: action.payload ? action.payload : "خطای پیش بینی نشده",
          success: null,
        }

      // Reset Messages
      case RESET_QUARTERTARIFF_MESSAGES:
        return {
          ...state,
          error: null,
          success: null,
        }

      default:
        return state
    }
  }

  export default reducer